// GSAP ScrollTrigger Animations
// Using global gsap and ScrollTrigger from local assets

// Wait for GSAP to load and register ScrollTrigger
function waitForGsap(callback) {
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
    callback();
  } else {
    setTimeout(() => waitForGsap(callback), 50);
  }
}

// Initialize animations when DOM is loaded
function initAnimations() {
  // Fade in animations for general content
  const fadeElements = document.querySelectorAll('[data-animate="fade"]');
  
  fadeElements.forEach((element) => {
    gsap.fromTo(
      element,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: element,
          start: 'top 85%',
          end: 'top 65%',
          toggleActions: 'play none none none',
        },
      }
    );
  });

  // Stagger animations for slideshows (left to right)
  const slideshows = document.querySelectorAll('[data-animate="slideshow"]');
  
  slideshows.forEach((slideshow) => {
    const slides = slideshow.querySelectorAll('[data-animate-slide]');
    
    if (slides.length > 0) {
      gsap.fromTo(
        slides,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.6,
          stagger: 0.15, // Stagger from left to right
          ease: 'power2.out',
          scrollTrigger: {
            trigger: slideshow,
            start: 'top 85%',
            end: 'top 65%',
            toggleActions: 'play none none none',
          },
        }
      );
    }
  });

  // Refresh ScrollTrigger after all animations are set up
  ScrollTrigger.refresh();
}

// Run on load and after Shopify section updates
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => waitForGsap(initAnimations));
} else {
  waitForGsap(initAnimations);
}

// Re-initialize on Shopify section render
document.addEventListener('shopify:section:load', () => {
  setTimeout(() => waitForGsap(initAnimations), 100);
});

document.addEventListener('shopify:section:reorder', () => {
  setTimeout(() => waitForGsap(initAnimations), 100);
});

